import { onMounted, onUnmounted, ref } from 'vue'
import {
  DUEL_COMPACT_MQ,
  DUEL_ROTATE_MQ,
  DUEL_SNUG_MQ,
  MENUS_NARROW_MQ,
  MENUS_PORTRAIT_MQ,
  MENUS_SHORT_MQ,
  isDuelCompactNow,
  isDuelSnugNow,
  isMenusCompactNow,
  isMenusNarrowNow,
  isMenusPortraitNow,
  isMenusShortNow,
  needsDuelRotateNow,
  mqMatches,
} from '../ui/compactLayout'

function bindMq(query: string, apply: (on: boolean) => void): () => void {
  const mq = window.matchMedia(query)
  const onChange = () => apply(mq.matches)
  onChange()
  mq.addEventListener('change', onChange)
  return () => mq.removeEventListener('change', onChange)
}

/**
 * Reactive compact / rotate flags. Safe to call from several Vue roots.
 */
export function useCompactLayout() {
  const duelCompact = ref(isDuelCompactNow())
  const duelSnug = ref(isDuelSnugNow())
  const needsRotate = ref(needsDuelRotateNow())
  const menusShort = ref(isMenusShortNow())
  const menusNarrow = ref(isMenusNarrowNow())
  const menusPortrait = ref(isMenusPortraitNow())
  const menusCompact = ref(isMenusCompactNow())
  const stops: Array<() => void> = []

  onMounted(() => {
    stops.push(
      bindMq(DUEL_COMPACT_MQ, (on) => {
        duelCompact.value = on
        menusShort.value = on
        menusCompact.value = on || mqMatches(MENUS_NARROW_MQ)
      }),
      bindMq(DUEL_SNUG_MQ, (on) => {
        duelSnug.value = on
      }),
      bindMq(DUEL_ROTATE_MQ, (on) => {
        needsRotate.value = on
      }),
      bindMq(MENUS_NARROW_MQ, (on) => {
        menusNarrow.value = on
        menusCompact.value = on || mqMatches(MENUS_SHORT_MQ)
      }),
      bindMq(MENUS_PORTRAIT_MQ, (on) => {
        menusPortrait.value = on
      }),
    )
  })

  onUnmounted(() => {
    for (const stop of stops) stop()
  })

  return {
    duelCompact,
    duelSnug,
    needsRotate,
    menusCompact,
    menusShort,
    menusNarrow,
    menusPortrait,
  }
}
